import { apiSlice } from "@/shared/api"

import { normalizeGroupSettings } from "../lib"

import type {
  GetGroupSettingsRequest,
  GetGroupSettingsResponse,
  GetMediaRestrictionsRequest,
  GetMediaRestrictionsResponse,
  GetNotificationPreferencesRequest,
  GetNotificationPreferencesResponse
} from "./types"

export const groupSettingsApi = apiSlice
  .enhanceEndpoints({ addTagTypes: ["GroupSettings", "MediaRestrictions", "NotificationPreferences"] })
  .injectEndpoints({
    endpoints: builder => ({
      getGroupSettings: builder.query<GetGroupSettingsResponse, GetGroupSettingsRequest>({
        query: ({ chatId }) => `/api/v1/group/settings?chat_id=${chatId}`,
        transformResponse: (data: GetGroupSettingsResponse) => normalizeGroupSettings(data),
        providesTags: (_result, _error, { chatId }) => [{ type: "GroupSettings" as const, id: `CHAT_${chatId}` }]
      }),

      getMediaRestrictions: builder.query<GetMediaRestrictionsResponse, GetMediaRestrictionsRequest>({
        query: ({ chatId }) => `/api/v1/group/rating/restrictions?chat_id=${chatId}`,
        providesTags: (_result, _error, { chatId }) => [{ type: "MediaRestrictions" as const, id: `CHAT_${chatId}` }]
      }),

      getNotificationPreferences: builder.query<GetNotificationPreferencesResponse, GetNotificationPreferencesRequest>({
        query: ({ chatId }) => `/api/v1/group/rating/notifications?chat_id=${chatId}`,
        providesTags: (_result, _error, { chatId }) => [
          { type: "NotificationPreferences" as const, id: `CHAT_${chatId}` }
        ]
      })
    })
  })

export const { useGetGroupSettingsQuery, useGetMediaRestrictionsQuery, useGetNotificationPreferencesQuery } =
  groupSettingsApi
